import { HeaderLogo } from "@globalgiving/components"
import { FC } from "react"
import { config } from "~/config"

const HeaderHomeLink: FC = () => (
  <HeaderLogo aria-label="Home" href={config.globalGivingBaseUrl} rel="noreferrer" target="_blank" />
)

export default HeaderHomeLink
